import type { AddToastFuctionProps, ToastProps } from '$lib/types';
import { writable, type Writable } from 'svelte/store';
import { v4 as uuidv4 } from 'uuid';

export const toasts: Writable<ToastProps[]> = writable([]);

/**
 * Создаёт всплывающее уведомление
 *
 * ## Params
 * @param title заголовок
 * @param message сообщение
 * @param type тип: "default" | "success" | "warning" | "error" = "default";
 * @param time время до пропадания = 5000
 */
export const addToast = ({ title, message, type = 'default', time = 5000 }: AddToastFuctionProps) => {
  const id = uuidv4();

  toasts.update((currentToasts) => {
    return [...currentToasts, { id, title, message, type, time }]
  });

  setTimeout(() => removeToast(id), time);
}

export const removeToast = (id: string) => {
  toasts.update((currentToasts) => {
    return currentToasts.filter((toast) => toast.id !== id)
  });
}
